<template>
  <router-view />
</template>

<script>
  export default {
    name: "MainComponent"
  }
</script>

<style scoped>

</style>
